import classNames from 'classnames'
import { memo } from 'react'

import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { tcgLandUrl } from '@/utils/constants'
import getRandomAd from '@/utils/getRandomAd'

import styles from './Sidebar.module.scss'

type Props = {
  country?: string
  isGuide?: boolean
}

const Sidebar = ({ country, isGuide }: Props) => {
  if (country === 'MX') {
    const randomAd = getRandomAd('tcg.land/sidebar')
    return (
      <div className={styles.sidebar}>
        <OutboundLink url={tcgLandUrl} utm_medium='sidebar'>
          <img alt='TCG.Land' className={styles.tcgland} src={randomAd.src} />
        </OutboundLink>
      </div>
    )
  }

  return <div className={classNames(styles.sidebar, 'mvSidebar1', { [styles.guide]: isGuide })} />
}

export default memo(Sidebar)
